import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { usePageMeta } from "../hooks/usePageMeta";
import { PageHeader } from "../components/PageHeader";
import { CtaBanner } from "../components/CtaBanner";
import { fadeUp, stagger } from "../lib/motion";
import { PERCORSI } from "../data/content";

export default function Percorsi() {
  usePageMeta(
    "I nostri percorsi",
    "Diplomi, lauree, corsi di formazione professionale e certificazioni linguistiche e informatiche: scopri i percorsi di Centro Studi Forma Futuro."
  );

  return (
    <main>
      <PageHeader
        testId="page-percorsi"
        eyebrow="I nostri percorsi"
        title="Ogni obiettivo ha il suo percorso."
        description="Diplomi, lauree, formazione professionale e certificazioni: ti aiutiamo a orientarti e a scegliere la strada giusta per te."
      />
      <motion.div
        variants={fadeUp}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
        className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 -mt-4 mb-12"
      >
        <span
          data-testid="percorsi-rateale-badge"
          className="inline-flex items-center gap-3 rounded-full bg-azure-light border border-azure-soft px-5 py-2.5 text-sm font-semibold text-navy"
        >
          <span className="w-2 h-2 rounded-full bg-azure shrink-0" />
          I nostri percorsi sono disponibili anche con pagamento rateale
        </span>
      </motion.div>
      <section className="pb-20 lg:pb-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
          <motion.div
            variants={stagger}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-60px" }}
            className="grid grid-cols-1 md:grid-cols-2 gap-7"
          >
            {PERCORSI.map((p) => (
              <motion.div key={p.slug} variants={fadeUp}>
                <Link
                  to={p.slug}
                  data-testid={`percorsi-page-card-${p.slug.replace("/", "")}`}
                  className="group relative block h-full rounded-[1.6rem] overflow-hidden bg-navy text-white min-h-[340px] transition-transform duration-500 hover:-translate-y-1.5"
                >
                  <img
                    src={p.image}
                    alt={p.titolo}
                    className="absolute inset-0 w-full h-full object-cover opacity-40 transition-all duration-700 group-hover:opacity-55 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/60 to-navy/10" />
                  <div className="relative h-full flex flex-col justify-end p-8 lg:p-10">
                    <span className="text-xs font-bold tracking-[0.25em] text-sky-300 mb-3">
                      {p.numero}
                    </span>
                    <h2 className="text-2xl lg:text-3xl font-extrabold tracking-tight">
                      {p.titolo}
                    </h2>
                    <p className="mt-3 text-sm text-white/70 leading-relaxed max-w-md">
                      {p.descrizione}
                    </p>
                    <span className="mt-6 inline-flex items-center gap-2 text-sm font-bold text-sky-300">
                      Vai alla pagina
                      <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
                    </span>
                  </div>
                </Link>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>
      <CtaBanner />
    </main>
  );
}
